import React from 'react';

import $image_url from 'js/utils/image_url';
import routes from 'js/core_pre_webpack/routes';

import OnsitePing, { Props as OnsitePingProps } from './onsite_ping';

import { $a, $r } from 'global';

interface Props extends OnsitePingProps {
  displayName: string;
  couponCode?: string;
  trialPrice?: string;
  trialDays?: string;
}

export default class AbandonedCartPing extends OnsitePing<Props> {
  closeRef: React.RefObject<HTMLButtonElement>;
  constructor(props: Props) {
    super(props);
    this.closeRef = React.createRef();
  }

  getBody() {
    const copy =
      'Get a full year of the most powerful tools in research for an amazing low price.';

    return (
      <div
        style={{ fontSize: '16px', lineHeight: '24px', letterSpacing: '0.2px' }}
      >
        <div>{copy}</div>
      </div>
    );
  }

  getButtonText() {
    if (this.props.trialPrice) {
      return `Try Premium for ${this.props.trialPrice} for ${this.props.trialDays} days ▸`;
    } else {
      return 'Get Academia Premium now for 50% off ▸';
    }
  }

  getHeadlineText() {
    if (this.props.couponCode) {
      return `Don't miss this exclusive offer, ${this.props.displayName}`;
    } else {
      return `Don't miss this great deal, ${this.props.displayName}`;
    }
  }

  getSubheadText() {
    if (this.props.trialPrice) {
      return '';
    } else {
      return 'Limited time offer. Get Academia Premium 50% off';
    }
  }

  renderTopSection() {
    return (
      <div
        className="ping-header"
        style={{
          height: '108px',
          backgroundImage: 'url(/images/onsite_pings/header-bg-jellyfish.png)',
        }}
      >
        <div className="close-button-wrapper" style={{ zIndex: 200 }}>
          <button
            ref={this.closeRef}
            className="close-button"
            onClick={this.createCloseTooltip(this.props.pingName)}
          >
            ×
          </button>
        </div>
        <div
          className="banner"
          style={{ position: 'absolute', top: '-6px', right: '-8px' }}
        >
          <img
            src={$image_url('onsite_pings/red_ribbon.svg')}
            style={{ width: '112px' }}
          />
          {this.props.trialPrice ? (
            <span
              style={{
                position: 'absolute',
                top: '34px',
                right: '19px',
                transform: 'rotate(45deg)',
                fontWeight: 'bold',
                fontSize: '16px',
              }}
            >{`${this.props.trialPrice} Trial`}</span>
          ) : (
            <span
              style={{
                position: 'absolute',
                top: '32px',
                right: '17px',
                transform: 'rotate(45deg)',
                fontWeight: 'bold',
                fontSize: '16px',
              }}
            >
              50% OFF
            </span>
          )}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            fontWeight: 500,
            textAlign: 'start',
            paddingTop: '12px',
            maxWidth: '75vw',
          }}
        >
          <div
            style={{
              fontSize: '22px',
              paddingBottom: '8px',
              lineHeight: '26px',
              letterSpacing: '1.22px',
              width: '90%',
              maxWidth: '75vw',
            }}
          >
            {this.getHeadlineText()}
          </div>
          {!$a.isSmallScreen() ? (
            <div
              style={{
                fontSize: '14px',
                lineHeight: '16px',
                letterSpacing: '0.2px',
              }}
            >
              {this.getSubheadText()}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  renderMainSection(): React.ReactNode {
    return (
      <div
        style={{ display: 'flex', flexDirection: 'row', padding: '20px 32px' }}
      >
        {this.getBody()}
      </div>
    );
  }

  getUpgradeURL() {
    if (this.props.couponCode) {
      return routes.checkout_url({
        feature: 'DEFAULT',
        trigger: 'abandoned_cart_ping',
        premium_discount_coupon: this.props.couponCode,
      });
    } else {
      return routes.checkout_url({
        feature: 'DEFAULT',
        trigger: 'abandoned_cart_ping',
      });
    }
  }

  redirectToUpgradeUrl = () => {
    $.ajax({
      type: 'POST',
      url: $r.record_ping_clickthrough_api_v0_onsite_pings_path({
        subdomain_param: 'api',
      }),
      contentType: 'application/json',
      processData: false,
      data: JSON.stringify({
        ping_name: this.props.pingName,
      }),
    });

    // @ts-ignore
    window.location = this.getUpgradeURL();
  };

  onBodyClick = (event: React.MouseEvent) => {
    if (event.target === this.closeRef.current) return;
    this.redirectToUpgradeUrl(); // TODO Replace with anchor tag.
  };

  renderButton() {
    return (
      <div className="ping-button">
        <button
          className="Button"
          style={{
            backgroundColor: '#A89241',
            borderRadius: '4px',
            lineHeight: '0',
            padding: '0 12px',
          }}
        >
          <span>{this.getButtonText()}</span>
        </button>
      </div>
    );
  }

  renderBasePing(): React.ReactNode {
    return (
      <div
        className="redesigned-ping-wrapper u-clickable"
        style={{ maxWidth: '100vw' }}
        onClick={this.onBodyClick}
      >
        {this.renderTopSection()}
        {this.renderMainSection()}
        {this.renderButton()}
      </div>
    );
  }
}
